import { FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402 } from "@faire/retailer-settings/FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402";
import { whitelist } from "@faire/retailer-visitor-shared/initializers/AutoSignUpInitializer";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { RouteMatcher } from "@faire/web--source/common/routes/RouteMatcher";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
import { useLocation } from "react-router-dom";

import { useIsLoggedInRetailer } from "../lib/isLoggedInRetailer";

import { useSettingIsPerfAppSemDiscoverTreatment } from "./useSettingPerfAppSemDiscover";

export const useIsEligibleForMobileLoggedOutNavUpdate = () => {
  const isPerfAppSemDiscoverPageTreatment =
    useSettingIsPerfAppSemDiscoverTreatment();
  const { isMobile } = useViewport();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const matcher = new RouteMatcher(whitelist);
  const location = useLocation();
  const isPageOnAllowedList = matcher.match(location?.pathname ?? "");

  return (
    !isPerfAppSemDiscoverPageTreatment &&
    isMobile &&
    !isLoggedInRetailer &&
    isPageOnAllowedList
  );
};

export const useSettingMobileLoggedOutNavUpdate = (): IFourVariantXP => {
  const setting = useSetting(FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402);
  const isEligible = useIsEligibleForMobileLoggedOutNavUpdate();
  return isEligible ? setting : IFourVariantXP.Bucket.CONTROL;
};

export const useAssignSettingMobileLoggedOutNavUpdate = () =>
  useAssignSetting(FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402);

export const useShouldShowUpdatedMobileSearch = () => {
  const setting = useSettingMobileLoggedOutNavUpdate();
  return (
    setting === IFourVariantXP.Bucket.VARIANT_2 ||
    setting === IFourVariantXP.Bucket.VARIANT_3
  );
};
